export default __webpack_public_path__ + "static/media/user_dashboard_9.31b9530d.jpg";